import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './CrystalDetails.module.scss';
import { CrystalDetail } from './types';

type CrystalDetailsProps = {
  data: CrystalDetail;
};

const textTransition = { duration: 0.45, ease: [0.16, 1, 0.3, 1] };

export function CrystalDetails({ data }: CrystalDetailsProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const compatibleCrystalsDescription = data.compatibleCrystalsDescription || '';
  const compatibleMetals = Array.isArray(data.compatibleMetals) ? data.compatibleMetals : [];

  useEffect(() => {
    setIsLoaded(false);
  }, [data.imageUrl]);

  return (
    <div className={styles.details}>
      <div className={styles.imageFrame}>
        {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
        <AnimatePresence mode="wait">
          <motion.img
            key={data.imageUrl}
            src={data.imageUrl}
            alt={data.name}
            className={`${styles.image} ${isLoaded ? styles.sharp : styles.blurred}`}
            onLoad={() => setIsLoaded(true)}
            loading="lazy"
            initial={{ opacity: 0, filter: 'blur(12px)' }}
            animate={{
              opacity: isLoaded ? 1 : 0,
              filter: isLoaded ? 'blur(0px)' : 'blur(12px)',
              transition: { duration: 0.75, ease: [0.16, 1, 0.3, 1] },
            }}
            exit={{
              filter: 'blur(16px)',
              opacity: 0,
              transition: {
                filter: { duration: 0.3, ease: 'easeIn' },
                opacity: { duration: 0.35, delay: 0.1 },
              },
            }}
          />
        </AnimatePresence>
      </div>

      <div className={styles.section}>
        <span className={styles.label}>С какими камнями сочетается</span>
        {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
        <AnimatePresence mode="wait">
          <motion.p
            key={`crystals-${data.name}`}
            className={styles.text}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={textTransition}
          >
            {compatibleCrystalsDescription}
          </motion.p>
        </AnimatePresence>
      </div>

      <div className={styles.section}>
        <span className={styles.label}>С какими металлами сочетается</span>
        {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
        <AnimatePresence mode="wait">
          <motion.p
            key={`metals-${data.name}`}
            className={styles.text}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={textTransition}
          >
            {compatibleMetals.join(', ')}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  );
}
